import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Client.List.IRequest;
type Response = Api.Core.Client.List.IResponse;
type Headers = Api.Core.Client.List.IHeaders;
const url = '/api/Claims/Client';
export default async function clientListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
